import Vue from 'vue';
import Pixel, {
  MpAccordion,
  MpAccordionHeader,
  MpAccordionIcon,
  MpAccordionItem,
  MpAccordionPanel,
  MpAutocomplete,
  MpAvatar,
  MpAvatarGroup,
  MpBadge,
  MpBanner,
  MpBannerCloseButton,
  MpBannerDescription,
  MpBannerIcon,
  MpBannerLink,
  MpBannerTitle,
  MpBox,
  MpButton,
  MpButtonGroup,
  MpButtonIcon,
  MpCheckbox,
  MpCheckboxGroup,
  MpCollapse,
  MpDatePicker,
  MpDivider,
  MpDrawer,
  MpDrawerBody,
  MpDrawerCloseButton,
  MpDrawerContent,
  MpDrawerFooter,
  MpDrawerHeader,
  MpDrawerOverlay,
  MpDropzone,
  MpFlex,
  MpFormControl,
  MpFormErrorMessage,
  MpFormHelpText,
  MpFormLabel,
  MpGrid,
  MpGridItem,
  MpHeading,
  MpIcon,
  MpImage,
  MpInput,
  MpInputGroup,
  MpInputLeftAddon,
  MpInputRightAddon,
  MpInputTag,
  MpListUpload,
  MpLoader,
  MpModal,
  MpModalBody,
  MpModalCloseButton,
  MpModalContent,
  MpModalFooter,
  MpModalHeader,
  MpModalOverlay,
  MpPopover,
  MpPopoverContent,
  MpPopoverHeader,
  MpPopoverList,
  MpPopoverListItem,
  MpPopoverPanel,
  MpPopoverTrigger,
  MpProgress,
  MpPseudoBox,
  MpRadio,
  MpRadioGroup,
  MpRating,
  MpSegmentedControl,
  MpSelect,
  MpSkeleton,
  MpSpinner,
  MpStack,
  MpTab,
  MpTabList,
  MpTabPanel,
  MpTabPanels,
  MpTable,
  MpTableBody,
  MpTableCell,
  MpTableContainer,
  MpTableHead,
  MpTableRow,
  MpTabs,
  MpTag,
  MpText,
  MpTextarea,
  MpTimeline,
  MpTimelineAccordion,
  MpTimelineCaption,
  MpTimelineContent,
  MpTimelineDocument,
  MpTimelineItem,
  MpTimelineLog,
  MpTimelineLogItem,
  MpTimelineTitle,
  MpToggle,
  MpTooltip,
  MpUpload,
} from '@mekari/pixel';
import { MpToast } from '@mekari/pixel-toast';

Vue.component('MpAutocomplete', MpAutocomplete);
Vue.component('MpAccordion', MpAccordion);
Vue.component('MpAccordionHeader', MpAccordionHeader);
Vue.component('MpAccordionIcon', MpAccordionIcon);
Vue.component('MpAccordionItem', MpAccordionItem);
Vue.component('MpAccordionPanel', MpAccordionPanel);
Vue.component('MpBox', MpBox);
Vue.component('MpDrawer', MpDrawer);
Vue.component('MpDrawerBody', MpDrawerBody);
Vue.component('MpDrawerCloseButton', MpDrawerCloseButton);
Vue.component('MpDrawerContent', MpDrawerContent);
Vue.component('MpDrawerFooter', MpDrawerFooter);
Vue.component('MpDrawerHeader', MpDrawerHeader);
Vue.component('MpDrawerOverlay', MpDrawerOverlay);
Vue.component('MpDropzone', MpDropzone);
Vue.component('MpPseudoBox', MpPseudoBox);
Vue.component('MpText', MpText);
Vue.component('MpFlex', MpFlex);
Vue.component('MpTable', MpTable);
Vue.component('MpTableContainer', MpTableContainer);
Vue.component('MpTableCell', MpTableCell);
Vue.component('MpTableRow', MpTableRow);
Vue.component('MpTableHead', MpTableHead);
Vue.component('MpTableBody', MpTableBody);
Vue.component('MpIcon', MpIcon);
Vue.component('MpAvatar', MpAvatar);
Vue.component('MpAvatarGroup', MpAvatarGroup);
Vue.component('MpBadge', MpBadge);
Vue.component('MpCollapse', MpCollapse);
Vue.component('MpGrid', MpGrid);
Vue.component('MpGridItem', MpGridItem);
Vue.component('MpHeading', MpHeading);
Vue.component('MpImage', MpImage);
Vue.component('MpInputGroup', MpInputGroup);
Vue.component('MpInput', MpInput);
Vue.component('MpInputRightAddon', MpInputRightAddon);
Vue.component('MpInputLeftAddon', MpInputLeftAddon);
Vue.component('MpInputTag', MpInputTag);
Vue.component('MpButton', MpButton);
Vue.component('MpButtonGroup', MpButtonGroup);
Vue.component('MpButtonIcon', MpButtonIcon);
Vue.component('MpTimeline', MpTimeline);
Vue.component('MpTimelineItem', MpTimelineItem);
Vue.component('MpTimelineTitle', MpTimelineTitle);
Vue.component('MpTimelineContent', MpTimelineContent);
Vue.component('MpTimelineDocument', MpTimelineDocument);
Vue.component('MpTimelineCaption', MpTimelineCaption);
Vue.component('MpTimelineAccordion', MpTimelineAccordion);
Vue.component('MpTimelineLogItem', MpTimelineLogItem);
Vue.component('MpTimelineLog', MpTimelineLog);
Vue.component('MpProgress', MpProgress);
Vue.component('MpDivider', MpDivider);
Vue.component('MpPopover', MpPopover);
Vue.component('MpPopoverTrigger', MpPopoverTrigger);
Vue.component('MpPopoverHeader', MpPopoverHeader);
Vue.component('MpPopoverContent', MpPopoverContent);
Vue.component('MpPopoverPanel', MpPopoverPanel);
Vue.component('MpPopoverListItem', MpPopoverListItem);
Vue.component('MpPopoverList', MpPopoverList);
Vue.component('MpSkeleton', MpSkeleton);
Vue.component('MpSpinner', MpSpinner);
Vue.component('MpStack', MpStack);
Vue.component('MpRating', MpRating);
Vue.component('MpRadio', MpRadio);
Vue.component('MpRadioGroup', MpRadioGroup);
Vue.component('MpModal', MpModal);
Vue.component('MpModalBody', MpModalBody);
Vue.component('MpModalContent', MpModalContent);
Vue.component('MpModalHeader', MpModalHeader);
Vue.component('MpModalOverlay', MpModalOverlay);
Vue.component('MpModalFooter', MpModalFooter);
Vue.component('MpModalCloseButton', MpModalCloseButton);
Vue.component('MpTabs', MpTabs);
Vue.component('MpTab', MpTab);
Vue.component('MpTabList', MpTabList);
Vue.component('MpTabPanels', MpTabPanels);
Vue.component('MpTabPanel', MpTabPanel);
Vue.component('MpTag', MpTag);
Vue.component('MpToggle', MpToggle);
Vue.component('MpBanner', MpBanner);
Vue.component('MpBannerLink', MpBannerLink);
Vue.component('MpBannerIcon', MpBannerIcon);
Vue.component('MpBannerDescription', MpBannerDescription);
Vue.component('MpBannerTitle', MpBannerTitle);
Vue.component('MpBannerCloseButton', MpBannerCloseButton);
Vue.component('MpDatePicker', MpDatePicker);
Vue.component('MpFormControl', MpFormControl);
Vue.component('MpFormLabel', MpFormLabel);
Vue.component('MpFormErrorMessage', MpFormErrorMessage);
Vue.component('MpFormHelpText', MpFormHelpText);
Vue.component('MpTextarea', MpTextarea);
Vue.component('MpTooltip', MpTooltip);
Vue.component('MpSegmentedControl', MpSegmentedControl);
Vue.component('MpSelect', MpSelect);
Vue.component('MpUpload', MpUpload);
Vue.component('MpListUpload', MpListUpload);
Vue.component('MpLoader', MpLoader);
Vue.component('MpCheckbox', MpCheckbox);
Vue.component('MpCheckboxGroup', MpCheckboxGroup);

Vue.use(Pixel);
Vue.use(MpToast);
